import React, { useEffect } from "react";
import AdminContainer from "./AdminContainer";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { hasAccessPermission } from "../../utils/routerHelpers";
import { useSelector } from "react-redux";
import DownloadFile from "../DownloadFile";

export default function AdminLayout() {
  const { adminToken, roleId } = useSelector((state) => state.token);
  const location = useLocation();

  if (!adminToken || !roleId) {
    // if verification process not completed, redirect to login
    return <Navigate to={`/admin/login?callback=${location.pathname}`} />;
  }

  if (!hasAccessPermission(location.pathname, roleId)) {
    return <Navigate to="/admin/dashboard" />;
  }
  return (
    <>
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap"
        />
        <style>
          {`
					body {
						font-family: 'Roboto', sans-serif !important;
					}
					`}
        </style>
      </Helmet>
      <AdminContainer>
        <Outlet />
        <DownloadFile />
      </AdminContainer>
    </>
  );
}
